import { all, fork } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import * as auth from './ducks/auth.duck';
import * as users from './ducks/users.duck';
import * as profile from './ducks/profile.duck';
import * as companies from './ducks/companies.duck';
import * as transactions from './ducks/transactions.duck';
import * as promocodes from './ducks/promocodes.duck';
import * as productForDays from './ducks/product-for-days.duck';

import * as categories from './ducks/categories.duck';
import * as products from './ducks/product.duck';
import * as productTypes from './ducks/productType.duck';
import * as orders from './ducks/orders.duck';
import * as agreement from './ducks/agreement.duck';
import * as yaLocations from './ducks/yaLocations.duck';
import * as stores from './ducks/store.duck';
import * as cart from './ducks/cart.duck';
import * as blog from './ducks/blog.duck';
import * as messages from './ducks/messages.duck';
import * as tariff from './ducks/tariff.duck';
import * as productsCatalog from './ducks/product-catalog.duck';
import * as chat from './ducks/chat.duck';
import * as tenders from './ducks/tenders.duck';
import * as delivery from './ducks/delivery.duck';
import * as supply from './ducks/supply.duck';
import * as stat from './ducks/statistics.duck';
import * as search from './ducks/search.duck';
import * as banners from './ducks/banners.duck';
import * as request from './ducks/request.duck'
import * as loyalty from './ducks/loyalty.duck'

import { base } from '../../_base';

export type TAppActions =
  | auth.TActions
  | companies.TActions
  | transactions.TActions
  | promocodes.TActions
  | users.TActions
  | profile.TActions
  | categories.TActions
  | products.TActions
  | productForDays.TActions
  | productTypes.TActions
  | orders.TActions
  | agreement.TActions
  | yaLocations.TActions
  | stores.TActions
  | cart.TActions
  | blog.TActions
  | tariff.TActions
  | messages.TActions
  | productsCatalog.TActions
  | chat.TActions
  | tenders.TActions
  | delivery.TActions
  | stat.TActions
  | search.TActions
  | supply.TActions
  | banners.TActions
  | request.TActions
  | loyalty.TActions;

export interface IAppState {
  i18n: typeof base.i18n.reducer;
  builder: typeof base.builder.initialState;
  auth: auth.IInitialState & PersistPartial;
  companies: companies.IInitialState & PersistPartial;
  banners: banners.IInitialState & PersistPartial;
  promocodes: promocodes.IInitialState & PersistPartial;
  transactions: transactions.IInitialState & PersistPartial;
  users: users.IInitialState & PersistPartial;
  profile: profile.IInitialState & PersistPartial;
  categories: categories.IInitialState & PersistPartial;
  products: products.IInitialState & PersistPartial;
  productForDays: productForDays.IInitialState & PersistPartial;
  productTypes: productTypes.IInitialState & PersistPartial;
  orders: orders.IInitialState & PersistPartial;
  agreement: agreement.IInitialState;
  yaLocations: yaLocations.IInitialState;
  stores: stores.IInitialState & PersistPartial;
  cart: cart.IInitialState & PersistPartial;
  blog: blog.IInitialState & PersistPartial;
  messages: messages.IInitialState & PersistPartial;
  tariff: tariff.IInitialState & PersistPartial;
  productsCatalog: productsCatalog.IInitialState & PersistPartial;
  chat: chat.IInitialState & PersistPartial;
  tenders: tenders.IInitialState & PersistPartial;
  delivery: delivery.IInitialState & PersistPartial;
  supply: supply.IInitialState & PersistPartial;
  stat: stat.IInitialState & PersistPartial;
  search: search.IInitialState & PersistPartial;
  request: request.IInitialState & PersistPartial;
  loyalty: loyalty.IInitialState & PersistPartial;
}

export const rootReducer: (
  state: IAppState,
  action: TAppActions
) => IAppState = combineReducers<IAppState, TAppActions>({
  auth: auth.reducer,
  companies: companies.reducer,
  transactions: transactions.reducer,
  promocodes: promocodes.reducer,
  users: users.reducer,
  banners: banners.reducer,
  profile: profile.reducer,
  i18n: base.i18n.reducer,
  builder: base.builder.reducer,
  categories: categories.reducer,
  products: products.reducer,
  productForDays: productForDays.reducer,
  productTypes: productTypes.reducer,
  orders: orders.reducer,
  agreement: agreement.reducer,
  yaLocations: yaLocations.reducer,
  stores: stores.reducer,
  cart: cart.reducer,
  blog: blog.reducer,
  tariff: tariff.reducer,
  messages: messages.reducer,
  productsCatalog: productsCatalog.reducer,
  chat: chat.reducer,
  tenders: tenders.reducer,
  delivery: delivery.reducer,
  supply: supply.reducer,
  stat: stat.reducer,
  search: search.reducer,
  request: request.reducer,
  loyalty: loyalty.reducer
});

export function* rootSaga() {
  yield all(
    [
      auth.saga,
      companies.saga,
      transactions.saga,
      promocodes.saga,
      users.saga,
      profile.saga,
      banners.saga,
      categories.saga,
      stores.saga,
      products.saga,
      productForDays.saga,
      productTypes.saga,
      orders.saga,
      agreement.saga,
      yaLocations.saga,
      cart.saga,
      blog.saga,
      messages.saga,
      tariff.saga,
      productsCatalog.saga,
      chat.saga,
      tenders.saga,
      delivery.saga,
      supply.saga,
      stat.saga,
      search.saga,
      request.saga,
      loyalty.saga
    ].map(saga => fork(saga))
  );
}
